export const DEFAULT_AXIS_THEME = {
    title: {
        space: 4,
        padding: 0,
        textStyle: {
            fontSize: 12,
            fill: "#333333",
            fontWeight: "normal",
            fillOpacity: 1
        }
    },
    label: {
        visible: !0,
        inside: !1,
        space: 4,
        padding: 0,
        style: {
            fontSize: 12,
            fill: "#333",
            fontWeight: "normal",
            fillOpacity: 1
        }
    },
    tick: {
        visible: !0,
        inside: !1,
        alignWithLabel: !0,
        length: 4,
        style: {
            lineWidth: 1,
            stroke: "#000",
            strokeOpacity: 1
        }
    },
    subTick: {
        visible: !1,
        inside: !1,
        count: 4,
        length: 2,
        style: {
            lineWidth: 1,
            stroke: "#999",
            strokeOpacity: 1
        }
    },
    line: {
        visible: !0,
        style: {
            lineWidth: 1,
            stroke: "#000",
            strokeOpacity: 1
        }
    }
};
//# sourceMappingURL=config.js.map